// Lucide icon: image (https://lucide.dev/icons/image)
import { Image } from 'lucide-react'

import { IconComponentStyled } from '../styles/IconComponentStyled'
import { type IIconComponentProps } from '../types'

export const IconImage = (props: IIconComponentProps) => {
  return (
    <IconComponentStyled {...props}>
      <Image />
    </IconComponentStyled>
  )
}
